import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import css from './index.scss';
import { DARK } from '../button/variants';
import Button from '../button';
import Messages from './messages';
import inputStyle from './text-input.scss';
import TextInput from '../text-input';

class authenticate extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { password: '' };
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.props.handleOnContinue();
        }
    };

    OnPasswordChange = (event) => {
        this.setState({ password: event.target.value });
        this.props.handleOnPasswordChange(event);
    }

    render() {
        return (<div className={css.modalContent}>
            <div className={css.modalHeader}>
                <div className={css.modalHeaderText}>{this.props.intl.formatMessage(Messages.pageTitle)}</div>
                <div className={css.close} onClick={this.props.handleOnCancel} role="button" tabIndex={0}>&times;</div>
            </div>
            <div className={css.modalBody}>
                <div className={css.password}>{this.props.intl.formatMessage(Messages.password)}</div>
                <div><TextInput
                    css={inputStyle}
                    handleOnChange={this.OnPasswordChange}
                    handleOnKeyPress={this.handleKeyPress}
                    maxLength={50}
                    name="adminPassword"
                    type="password"
                /></div>
            </div>
            <div className={css.modalFooter}>
                <div className={css.buttonContainer}><Button
                    disabled={!this.state.password}
                    handleOnClick={this.props.handleOnContinue}
                    label={this.props.intl.formatMessage(Messages.continue)}
                    variant={DARK}
                /></div>
            </div>
        </div>);
    }
}

authenticate.propTypes = {
    intl: intlShape.isRequired,
    handleOnCancel: PropTypes.func,
    handleOnPasswordChange: PropTypes.func,
    handleOnContinue: PropTypes.func
};

export default injectIntl(styleable(css)(authenticate));



// WEBPACK FOOTER //
// ./app/components/authentication/index.js